import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/userActions";
import * as api from "../../api/userApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getUserInformation(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserInfo(action.payload);
        yield put(actions.setUserInfo(data || undefined));
    } catch (error) {
        yield put(actions.setUserInfo(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* checkUserRole(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.checkUserRole(action.payload);
        yield put(actions.setcheckUserRole(data.resultObject));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUserList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUsers(action.payload);
        yield put(actions.setUserList({ resultObject: data } || undefined));
        //yield put(actions.resetList());
    } catch (error) {
        yield put(actions.setUserList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlants() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPlants();
        yield put(actions.setPlants(data || undefined));
    } catch (error) {
        yield put(actions.setPlants(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateRecord(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateUsers(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteRecord(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteUsers(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addRecord(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addUsers(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUserPlantList(action) {
    yield put(resetBackdrop());
    try {
        if (action.payload.fromUser) {
            const { data } = yield api.getUserPlantList(action.payload.userCode);
            yield put(actions.setPlantsForUser(data || undefined));
        } else {
            const { data } = yield api.getUserPlantList(action.payload.userCode);
            yield put(actions.setUserPlantList(data || undefined));
        }
    } catch (error) {
        yield put(actions.setUserPlantList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUserMenuList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserMenuList(action.payload);
        yield put(actions.setUserMenuList(data || undefined));
        yield put(actions.getUserInterfaceList());
    } catch (error) {
        yield put(actions.setUserMenuList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getUserInterfaceList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserInterfaceList(action.payload);
        yield put(actions.setUserInterfaceList(data || undefined));
    } catch (error) {
        yield put(actions.setUserInterfaceList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUserDetailbyID(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserDetailByID(action.payload);
        yield put(actions.setUserDetailbyID(data || undefined));
    } catch (error) {
        yield put(actions.setUserDetailbyID(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUserGroupList() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserGroupList();
        yield put(actions.setUserGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setUserGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUserRoleGroupList() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUserRoleGroupList();
        yield put(actions.setUserRoleGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setUserRoleGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTechnicianList() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTechnicianList();
        yield put(actions.setTechnicianList(data || undefined));
    } catch (error) {
        yield put(actions.setTechnicianList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateUserGroupbyId(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateUserGroupsbyid(action.payload);
        yield put(actions.setupdateUserGroupbyId(data || undefined));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.setupdateUserGroupbyId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateUserRoleGroupbyId(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateUserRoleGroupsbyid(action.payload);
        yield put(actions.setupdateUserRoleGroupbyId(data || undefined));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        // yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.setupdateUserRoleGroupbyId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTechnicianListByPoolId(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTechnicianListByPoolId(action.payload);
        yield put(actions.setTechnicianListByPoolId(data || undefined));
    } catch (error) {
        yield put(actions.setTechnicianListByPoolId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCostCenterList() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getCostCenterList();
        console.log({ data });
        yield put(actions.setCostCenterList(data));
    } catch (error) {
        yield put(actions.setCostCenterList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentReportGroupList() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEquipmentReportGroupList();
        yield put(actions.setEquipmentReportGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentReportGroupList(undefined));
    }
    yield put(setBackdrop());
}

function* postMaintenanceApprovalRights(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.postMaintenanceApprovalRights(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMaintenanceApprovalRights(action) {
    yield put(resetBackdrop());
    try {
        console.log(action.payload);
        const { data }  = yield api.getMaintenanceApprovalRights(action.payload);
        yield put(actions.setMaintenanceApprovalRights(data || undefined));
    } catch (error) {
        yield put(actions.setMaintenanceApprovalRights(undefined));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_USER_LIST, getUserList);
    yield takeEvery(actions.Types.UPDATE_RECORD_OF_USER, updateRecord);
    yield takeEvery(actions.Types.DELETE_RECORD_OF_USER, deleteRecord);
    yield takeEvery(actions.Types.ADD_RECORD_OF_USER, addRecord);
    yield takeEvery(actions.Types.GET_PLANTS_FOR_USER, getPlants);
    yield takeEvery(actions.Types.GET_USER_INFORMATION, getUserInformation);
    yield takeEvery(actions.Types.CHECK_USER_ROLE, checkUserRole);
    yield takeEvery(actions.Types.GET_USER_PLANT_LIST, getUserPlantList);
    yield takeEvery(actions.Types.GET_USER_MENU_LIST, getUserMenuList);
    yield takeEvery(actions.Types.GET_USER_INTERFACE_LIST, getUserInterfaceList);
    yield takeEvery(actions.Types.GET_USER_DETAIL_BY_ID, getUserDetailbyID);
    yield takeEvery(actions.Types.GET_USER_GROUP_LIST, getUserGroupList);
    yield takeEvery(actions.Types.GET_USER_ROLE_GROUP_LIST, getUserRoleGroupList);
    yield takeEvery(actions.Types.GET_TECHNICIAN_LIST, getTechnicianList);
    yield takeEvery(actions.Types.UPDATE_USER_GROUP_BY_ID, updateUserGroupbyId);
    yield takeEvery(actions.Types.UPDATE_USER_ROLE_GROUP_BY_ID, updateUserRoleGroupbyId);
    yield takeEvery(actions.Types.GET_TECHNICIAN_LIST_BY_POOL_ID, getTechnicianListByPoolId);
    yield takeEvery(actions.Types.GET_COST_CENTER_FOR_USER, getCostCenterList);
    yield takeEvery(actions.Types.GET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER, getEquipmentReportGroupList);
    yield takeEvery(actions.Types.POST_MAINTENANCE_APPROVAL, postMaintenanceApprovalRights);
    yield takeEvery(actions.Types.GET_MAINTENANCE_APPROVAL, getMaintenanceApprovalRights);
}
const userSagas = [fork(watchAll)];

export default userSagas;
